// extracted by mini-css-extract-plugin
export var billingAddress = "_xt-g";
export var contactInfo = "_xt-d";
export var customerInfoContainer = "_xt-c";
export var customerInfoContainerMobile = "_xt-h";
export var customerInfoRow = "_xt-a";
export var customerInfoSection = "_xt-b";
export var fullWidthDividerMobile = "_xt-i";
export var imageContainer = "_xt-1";
export var paymentMethod = "_xt-e";
export var priceText = "_xt-6";
export var priceTextMobile = "_xt-7";
export var product = "_xt-0";
export var productImage = "_xt-2";
export var productInfo = "_xt-4";
export var productMobile = "_xt-9";
export var productTitle = "_xt-8";
export var quantityBadge = "_xt-3";
export var quantityText = "_xt-5";
export var shippingAddress = "_xt-f";